import { HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService, AppServerAPI } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-transport-photo-button',
  templateUrl: './transport-photo-button.component.html',
  styleUrls: ['./transport-photo-button.component.scss']
})
export class TransportPhotoButtonComponent {

  @Output() onDocumentUploaded = new EventEmitter();

  @Input() transportId: number;

  requestRunning = false;

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI,
    private dialogService: DialogService
  ) {

  }

  public handlePictureEvent(event: Event) {
    this.requestRunning = true;
    const files = (event.target as HTMLInputElement).files;
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        const current: File = files.item(i);
        const name = current.name;
        const type = current.type;

        if (current.size > 10 * 1024 * 1024) {
          this.dialogService.showInfoDialog(
              'tmc-yard.ui.transport.details.dialog.invalid-file-size.title',
              'tmc-yard.ui.transport.details.dialog.invalid-file-size.message');
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {
          this.saveDocument(type, name, reader.result);
        };
        reader.readAsArrayBuffer(current);

      }
    }
  }

  private saveDocument(type: string, name: string, content: any) {
    console.log(content);
    return this.appServerAPI.postFile(`/client/control/transport/details/document/upload`, content, new HttpHeaders({
      'Content-Type': type,
      'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
      transportId: '' + this.transportId,
      filename: encodeURIComponent(name)
    })).toPromise().then(response => {
      console.log('saveDocument call succeeded:', response);
      this.onDocumentUploaded.next();
      this.requestRunning = false;
    }, error => {
      console.log('saveDocument call failed:', error);
      this.requestRunning = false;
    });
  }

}
